import React, { useState, useContext, ReactElement } from 'react'
import { useNavigate, Link, useLocation } from "react-router-dom"
import Cookies from "js-cookie";
import _ from "lodash";
import { isMobileOnly, isDesktop } from "react-device-detect"
import { Layout, Button, theme, App, Space, Affix, Avatar, Dropdown, Typography, Breadcrumb, Badge } from 'antd'
import { FaOutdent, FaIndent, FaSignOutAlt, FaRegUser, FaEnvelope, FaMobileAlt, FaUserEdit, FaShoppingCart, FaMapSigns, FaFileAlt, FaChevronLeft } from "react-icons/fa";
import { getRoutes } from "./route";
import language from "../../resources/languages/fa_IR";
import { ActionType, Enum, API } from "../../resources/constants";

// Interfaces
import { AxiosError } from "../../interfaces/axios";
import { Route } from "../../interfaces/layouts/dashboard";

// Contexts
import GlobalContext from '../../contexts/global'
import AxiosContext from '../../contexts/axios'

const { Header } = Layout
const { Message: MessageLanguage, Layouts: { Dashboard: { Route: RouteLanguage } } } = language
const { SET_USER, SET_ACCESS_TOKEN } = ActionType
const { Message } = Enum
const { USER_MANAGEMENT_AUTH_SIGN_OUT, FILE_MANAGEMENT_FILE_DOWNLOAD } = API

export default function Index({ collapsed, setCollapsed }: { collapsed: boolean, setCollapsed: (collapsed: boolean) => void }) {

  const { token: { colorBgContainer } } = theme.useToken()
  const { user, baseURL, accessToken, dispatch } = useContext(GlobalContext)
  const { axios } = useContext(AxiosContext)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const splitPathname= pathname.split("/").filter(item => item).map(item => '/' + item)
  if (_.isEmpty(splitPathname)) splitPathname.push('/')
  const { message } = App.useApp()
  const routes = [...getRoutes(user)];

  const signOut = () => {
    axios.get(USER_MANAGEMENT_AUTH_SIGN_OUT).then((response: {}) => {
      Cookies.remove('accessToken')
      dispatch({ type: SET_ACCESS_TOKEN , payload: { accessToken: null }})
      dispatch({ type: SET_USER , payload: { user: null }})
      message.success(MessageLanguage[Message.SIGN_OUT_PROFILE]).then(response => response)
      navigate("/")
    }).catch((error: AxiosError) => {
      const { response: { data } } = error;
      // @ts-ignore
      message.error(data.message).then(response => response )
    })
  }

  const flattenRoutes = (routes: Route[], flatten: Route[]) => {
    for (const route of routes)
      if (route.children)
        flattenRoutes(route.children, flatten)
    flatten.push(...routes)
  }

  const collapse = (
        <Button
            icon={collapsed ? <FaOutdent /> : <FaIndent />}
            onClick={() => setCollapsed(!collapsed)}
            className='collapsed'
        />
    )

  const breadcrumbs = () => {
    const items: { title: string|ReactElement }[] = []
    const flatten: Route[] = []
    flattenRoutes(routes, flatten)
    for (let i = 0; i < splitPathname.length; i++) {
      for (let j = 0; j <= i; j++) {
        if (j === i) {
          const route = _.findLast(flatten, { key: splitPathname.slice(0, j + 1).join('') });
          if (route?.key) route?.parent ? items.push({ title: route?.label }) : items.push({ title: <Link to={route.key}>{route?.label}</Link> });
        }
      }
    }

    return items;
  }

    return (
        <Header style={{background: colorBgContainer}}>
            <Space>
              <Space size={15}>
                {
                    isMobileOnly ? (
                    <Affix offsetTop={12}>
                      {collapse}
                    </Affix>
                  ) : collapse
                }
                <Breadcrumb items={breadcrumbs()} separator={<FaChevronLeft size={12}/>} className={isMobileOnly ? 'mr-2' : 'mr-6'} />
              </Space>
              <Space size={15}>
               <Space size={5}>
                 <Typography.Text>{user?.firstName} {user?.lastName}</Typography.Text>
                 <Typography.Link href={`tel:+98${user?.mobile}`}>(0{user?.mobile})</Typography.Link>
               </Space>
                <Dropdown
                  align={{
                    offset:[0,2]
                  }}
                  menu={{
                    items: [
                      {
                        key: "profile",
                        label: <Link to={'/profile'}><Space size={10} align={'baseline'}><FaUserEdit /><Typography.Text>{RouteLanguage.profile}</Typography.Text></Space></Link>,
                      },
                      {
                        key: "mobile",
                        label: <Link to={'/mobile'}><Space size={10} align={'baseline'}><FaMobileAlt /><Typography.Text>{RouteLanguage.mobile}</Typography.Text></Space></Link>,
                      },
                      {
                        key: "email",
                        label: <Link to={'/email'}><Space size={10} align={'baseline'}><FaEnvelope /><Typography.Text>{RouteLanguage.email}</Typography.Text></Space></Link>,
                      },
                      {
                        key: "sign-out",
                        label: <Space size={10} align={'baseline'}><FaSignOutAlt /><Typography.Text>{RouteLanguage.signOut}</Typography.Text></Space>,
                        onClick: signOut
                      }
                    ]
                  }}
                  trigger={["click"]}
                  placement="bottomLeft"
                >
                  <Avatar size={50} style={{marginLeft:15,cursor:'pointer'}} icon={user?.avatar ? <img src={baseURL + FILE_MANAGEMENT_FILE_DOWNLOAD + user.avatar + `?width=50&height=50&token=${accessToken}`} width={50} /> : <FaRegUser />} />
                </Dropdown>
              </Space>
            </Space>
        </Header>
    )
}
